// Vendor imports
const classNames = require('classnames')
const PropTypes = require('prop-types')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const CollectionModelRecord = require('client-v2/common/models/collection/record')

const bem = BemEntity('ShareModalCollectionContent')

function ShareModalCollectionContent(props) {
  const { collection } = props
  return (
    tag('div', {
      className: classNames(
        props.className,
        bem.block()
      )
    },
      collection.name,
      ' by ',
      '@' + collection.username
    )
  )
}

ShareModalCollectionContent.propTypes = {
  className: PropTypes.string,
  collection: PropTypes.shape(CollectionModelRecord.propTypes)
}

module.exports = ShareModalCollectionContent
